import IGlassWallDoor from 'components/interfaces/IGlassWallDoor';
import IGlassWallGlass from 'components/interfaces/IGlassWallGlass';
import IWall from 'components/interfaces/IWall';

import glassWallPartTypes from '../types/glassWallPartTypes';

const getDoorsFromWallParts = (wall: IWall): IGlassWallDoor[] =>
  wall.parts.filter(
    (part: IGlassWallDoor | IGlassWallGlass): part is IGlassWallDoor =>
      part.type === glassWallPartTypes.door
  );

export default getDoorsFromWallParts;
